<footer class="sticky-footer">
  <div class="container">
    <div class="text-center">
      <small>
        <!-- <i class="fa fa-copyright" aria-hidden="true"></i> STDAG v{{version}} {{year | date: 'yyyy'}}. Agencia de
        Calidad de la Educación-->
        <i aria-hidden="true"></i> Agencia de
        Calidad de la Educación | STDAG v{{version}} | {{year | date: 'yyyy'}}
      </small>
    </div>
  </div>
</footer>